import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { Store, select } from '@ngrx/store';
import { ZefReactiveComponent } from '@zerops/zef/core';
import { selectZefDialogState, zefDialogClose, ZefDialogModule } from '@zerops/zef/dialog';
import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiTipCardComponent } from '@zerops/zui/tip-card';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FEATURE_NAME } from './token-display-dialog.constant';

@Component({
  selector: 'z-token-display-dialog',
  templateUrl: './token-display-dialog.feature.html',
  styleUrl: './token-display-dialog.feature.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    ZefDialogModule,
    ZefCopyToClipboardModule,
    FormSectionModule,
    ZuiTipCardComponent
  ]
})
export class TokenDisplayDialogFeature extends ZefReactiveComponent {
  // # Deps
  #store = inject(Store);

  // # Event Streams
  onClose$ = new Subject<void>();

  // # Data
  // -- sync
  key = FEATURE_NAME;

  // -- async
  dialogState$ = this.#store.pipe(select(selectZefDialogState(FEATURE_NAME)));
  open$ = this.dialogState$.pipe(map((data) => data?.state));
  tokenName$ = this.dialogState$.pipe(map((data) => data?.meta?.name));
  tokenValue$ = this.dialogState$.pipe(map((data) => data?.meta?.token));
  isRegenerate$ = this.dialogState$.pipe(map((data) => data?.meta?.isRegenerate ?? false));
  isPersonal$ = this.dialogState$.pipe(map((data) => data?.meta?.isPersonal ?? false));

  // # State resolver
  state = this.$connect({
    open: this.open$,
    tokenName: this.tokenName$,
    tokenValue: this.tokenValue$,
    isRegenerate: this.isRegenerate$,
    isPersonal: this.isPersonal$
  });

  // # Dispatcher
  constructor() {
    super();

    this.$dispatchActions([
      this.onClose$.pipe(
        map(() => zefDialogClose({ key: FEATURE_NAME }))
      )
    ]);
  }
}
